import React, { Component } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  FormGroup,
  Label,
  InputGroup
} from "reactstrap";
import * as rxjs from "rxjs";
import { debounceTime } from "rxjs/operators";
import { isIE } from 'react-device-detect';

import { getMessage, changeLanguage } from "CONFIG/i18n";
import { systemAnnouncementAction } from "CONFIG/ActionFactory";
import { LANGUAGES, APP_CONFIG, DEFAULT_LANGUAGE, NAME_NG_REGEX } from "UTILS/Constants";
import { getAnnouncementUser, checkEmpty, getURLParameter, isAnnouncementBlank } from "UTILS/Utility";

import "./SplashScreen.less";

class AgentSplashScreen extends Component {
  constructor(props) {
    super(props);
    this.interval = null;
    this.repeatInterval = 1000; // 1000 ms == 1 seconds
    this.state = {
      count: 0,
      isDisableStartSession: false,
    };
    this.startSessionObserver = new rxjs.Subject();
  }

  componentDidMount() {
    this.setStartSessionReady();
    this.startSessionObserver.pipe(debounceTime(500)).subscribe(fn => {
      if (typeof fn === "function") fn();
    });
  }

  setStartSessionReady = () => {
    this.interval = setInterval(() => {
      if (this.state.count >= 5) { this.handleStartClick(); }
      this.setState({
        count: this.state.count + 1
      });
    }, this.repeatInterval);
  }

  handleStartClick = event => {
    if (this.state.isDisableStartSession) return;
    this.state.isDisableStartSession = true;
    this.props.handleStartClick();
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <div className="splashScreenMain flexDirectionColumn agentSplashScreenMain">
        <div>
          {this.state.activeAnnouncements && isAnnouncementBlank(this.state.activeAnnouncements, getMessage("USER_QRCODE_SCREEN")) && 
            <marquee>
              <label className="announcementLabel mt-2">
                {getAnnouncementUser(this.state.activeAnnouncements, window.location.href)}
              </label>
            </marquee>
          }
        </div>
        <div className="logoImage pt-4">
          <Row className="displayBlockIE">
            <Col className="logoImage flexForImage">
              <label className="agentJoinLabel">
                {getMessage("QR_AGENT_START_1")}
              </label>
            </Col>
          </Row>
          <Row className="displayBlockIE">
            <Col className="logoImage flexForImage pt-2">
              <label className="waitingLabel">
                {getMessage("QR_AGENT_START_2")}
                <a href='#' className="helpLink" onClick={() => { this.handleStartClick(); return false; }}>
                  {getMessage("QR_AGENT_START_3")}
                </a>
                {getMessage("QR_AGENT_START_4")}
              </label>
            </Col>
          </Row>
          <Row className="displayBlockIE">
            <Col className="logoImage flexForImage pt-4">
              <div className="roundLoader"></div>
              {" "}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default AgentSplashScreen;
